export const BASE_PAGINATION_REQUEST_PARAMS = {
  "page[size]": 10,
  "page[number]": 1
};
